import { render } from "./Create75Liquidation4.vue?vue&type=template&id=0bdc0757"
import script from "./Create75Liquidation4.vue?vue&type=script&lang=js"
export * from "./Create75Liquidation4.vue?vue&type=script&lang=js"

import "./Create75Liquidation4.vue?vue&type=style&index=0&id=0bdc0757&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__